import * as yup from 'yup';

export const normalizeString = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const valueMatchWithQuery = (
  value: string,
  queryToMatch: string,
  normalizeFunction = normalizeString,
) => {
  const isValidQuery = yup.string().trim().required().isValidSync(queryToMatch);
  if (!isValidQuery) {
    return true;
  }
  const normalizedQuery = normalizeFunction(queryToMatch);
  const normalizedValue = normalizeFunction(value);
  const match = normalizedValue.includes(normalizedQuery);
  return match;
};
